// removed by extract-text-webpack-plugin
module.exports = {"newProjectBox":"NewProject__newProjectBox__3azx8","titleBox":"NewProject__titleBox__tsswk","titleDes":"NewProject__titleDes__3JbA8","formBox":"NewProject__formBox__hBPqu","formItem":"NewProject__formItem__kETDz","error":"NewProject__error__2g_fp","textareaFormItem":"NewProject__textareaFormItem__3vT2X","labelDes":"NewProject__labelDes__1tJfD","labelMarkDes":"NewProject__labelMarkDes__GUBdv","imageBox":"NewProject__imageBox__DVpoB","textBtn":"NewProject__textBtn__P0L3W"};


//////////////////
// WEBPACK FOOTER
// ./src/views/newProject/NewProject.styl
// module id = 756
// module chunks = 0